export default __webpack_public_path__ + "static/media/bg_w_herramientas.80654853.png";